import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

export interface CustomResponse {
  error?: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class ZypeService {
  baseUrl: string = '';

  constructor(private httpClient: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  customerConsent(): Observable<CustomResponse> {
    return this.httpClient.post<CustomResponse>(this.baseUrl + 'zype/customer-consent', {});
  }

  createApplication(): Observable<CustomResponse> {
    return this.httpClient.post<CustomResponse>(this.baseUrl + 'zype/create-application', {});
  }
}
